<div class="error-container">
  <div class="error" *ngFor="let error of errorService.allErrors | async; trackBy: trackByFn" [@slideInOut]>
    <i class="material-icons error-icon">error</i>
    <div class="error-text is-flex-column has-flex-align-start has-flex-content-center">
      <div class="is-flex has-flex-align-end">
        <h4 translate="error.error"></h4>
        <span *ngIf="error.code" class="error-code">{{ 'error.errorCode' | translate }}{{ error.code }}</span>
      </div>
      <div [translate]="'error.' + error.msgKey"></div>
    </div>
    <i class="material-icons close-icon" role="button" tabindex="0" (click)="errorService.clearError(error.msgKey)">close</i>
  </div>
</div>